<template>
    <div
        class="comparison-item"
        :class="`comparison-item--${kebab(item.id)}`">
        <img
            :src="item.image"
            class="comparison-item__image">
        <div class="comparison-item__text">
            {{ valueText }}
        </div>
        <div
            v-if="item.info"
            class="comparison-item__info"
            tabindex="0"
            @focus="$refs.info.style.opacity = '1'; $refs.info.style.boxShadow = '0 2px 8px rgba(0,0,0,.125)';"
            @focusout="$refs.info.style = null;">
            <div class="comparison-item__info-icon">
                i
            </div>
            <div ref="info" class="comparison-item__info-text">
                {{ item.info }}
            </div>
        </div>
    </div>
</template>

<script>
import { kebabCase } from 'lodash';
export default {
    name: 'ComparisonItem',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            num: 0
        };
    },
    computed: {
        valueText () {
            return this.item.text.replace('#value#', this.num.toFixed(0));
        }
    },
    watch: {
        'item.value' (val) {
            this.$anime({
                targets: this,
                num: val,
                duration: 1000,
                easing: 'easeOutSine'
            });
        }
    },
    mounted () {
        const num = this.item.value;
        this.$anime({
            targets: this,
            num: num,
            duration: 1000,
            easing: 'easeOutSine'
        });
    },
    methods: {
        kebab (str) {
            return kebabCase(str);
        }
    }
};
</script>

<style lang="scss">
.comparison-item{
    position: relative;
    $block: &;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 50%;
    margin-bottom: spacing(7);
    @include breakpoint(medium down) {
        margin-bottom: spacing(5);
    }
    &__image{
        max-width: 100%;
        height: auto;
        margin-bottom: spacing(2);
        #{$block}--bus-cards &{
            width: 32px;
        }
        /*
        #{$block}--electric-bikes &{
            width: 106px;
        }
        #{$block}--bikes &{
            width: 108px;
        }
        #{$block}--taxi-rides &{
            width: 94px;
        }
        #{$block}--days-rental-car &{
            width: 97px;
        }
        #{$block}--jogging-shoes &{
            width: 94px;
        }
        #{$block}--kickbike-Rounds &{
            width: 94px;
        }
        #{$block}--num-rent-months &{
            width: 94px;
        }*/
    }
    &__text{
        text-align: center;
    }
    &__info{
        position: absolute;
        display: block;
        top: 4px;
        right: calc(50% - 40px);
        text-align: center;

        &:focus{
            outline: none;
        }
    }
    &__info-icon{
        cursor: pointer;
        position: absolute;
        width: 16px;
        height: 16px;
        transform: translateX(-50%);
        color: color(dark-grey);
        display: flex;
        font-size: 12px;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        overflow: hidden;
        border: solid 1px color(dark-grey);
    }
    &__info-text{
        position: absolute;
        top: 24px;
        left: 0;
        margin-left: -90px;
        width: 180px;
        opacity: 0;
        transition: opacity .25s ease;
        background-color: color(white, .96);
        padding: .125em .25em;
        line-height: 1.25em;
        font-size: 12px;
        .comparison-item__info-icon:hover ~ &{
            opacity: 1;
            box-shadow: 0 2px 8px rgba(0,0,0,.125);
        }
    }
}
</style>
